import React, {createContext, forwardRef} from 'react';
import _DataGrid from './ui';
import {
    DataGridEvents,
    DataGridInternalState,
    DataGridLayout,
    DataGridMisc,
    DataGridProps,
    DataGridSavedState,
    DefaultDataGridEvents,
    DefaultDataGridLayout,
    DefaultDataGridMisc,
    DefaultDataGridState
} from "./models";
import InternalDataGridController from "./core/models/in-app/controller/internal";
import DataGridController from "./core/models/in-app/controller";
import DataGridUtils from "./core/services/utils";

export const DataGridStateContext = createContext<DataGridInternalState>(DefaultDataGridState);
export const DataGridControllerContext = createContext<InternalDataGridController>(new InternalDataGridController());
export const DataGridLayoutContext = createContext<DataGridLayout>(DefaultDataGridLayout);
export const DataGridEventHandlersContext = createContext<DataGridEvents>(DefaultDataGridEvents);
export const DataGridMiscContext = createContext<DataGridMisc>(DefaultDataGridMisc);
export const DataGridSavedStateContext = createContext<DataGridSavedState>({
    loading: false,
    entries: [],
});
export const DataGridApplicationNameContext = createContext<string>('');

export interface DataGridScrollContextValue {
    getLayoutScrollParent: () => HTMLElement | null;
}

export const DataGridScrollContext = createContext<DataGridScrollContextValue>({
    getLayoutScrollParent: () => null,
});

/** Default max-height for `.data-grid-layout` scrollport when `virtualizationHeightFallback` is omitted. */
export const DEFAULT_DATA_GRID_LAYOUT_MAX_HEIGHT = undefined;

/** Minimum body row height (px) so empty rows and the row virtualizer do not collapse. */
export const DEFAULT_DATA_GRID_MIN_ROW_HEIGHT = 25;

// @ts-ignore
const DataGrid = forwardRef(_DataGrid as React.ForwardRefRenderFunction<DataGridController, DataGridProps>);

export const dataGridCellTextProps = DataGridUtils.cellTextProps;

// UseDataGridSavedState(name?: string, version?: number) -> [columns, sortBy, pageSize];
// DataGridProvider ({authorizationToken, storageKey})

export {default as DataGridProvider} from './ui/components/provider';
export {default as useDataGridSavedState} from './ui/hooks/use-data-grid-saved-state';

export * from './models';
export * from './core/services/utils/virtualization';
export * from './core/services/utils/scroll-parent';
export default DataGrid;
